export default __webpack_public_path__ + "static/media/已签到.552dc80d.png";